import { render, staticRenderFns } from "./related_gov_announces.vue?vue&type=template&id=08afcfc0&lang=pug"
import script from "./related_gov_announces.vue?vue&type=script&lang=js"
export * from "./related_gov_announces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports